"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoMatchResultDesc = exports.NoMatchResultHeader = exports.NoMatchResultWrapper = exports.ResultWrapper = exports.InputWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Wrapper = styled_components_1.default.div `
  background-color: ${colors_1.WHITE};
  max-width: 1200px;
  padding: 16px 0;

  ${(props) => !props.isPopup &&
    ` padding: 16px 32px 0;
    box-shadow: 0px 3px 8px ${colors_1.BLACK}10;`}

  @media (max-width: 687px) {
    padding: 16px 0 0;
  }
`;
exports.InputWrapper = styled_components_1.default.div ``;
exports.ResultWrapper = styled_components_1.default.div `
  display: flex;
  margin-top: 30px;
  flex-wrap: wrap;
  gap: 10px;
  height: 500px;
  overflow: scroll;

  > div {
    flex-basis: calc(33% - 60px);
  }

  @media (max-width: 687px) {
    display: block;
    height: 400px;
    -webkit-overflow-scrolling: touch;
    > div {
      flex-basis: 100%;
      gap: 0;
    }
  }

  @media (min-width: 686px) and (max-width: 1200px) {
    > div {
      flex-basis: calc(50% - 60px);
    }
  }
`;
exports.NoMatchResultWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-basis: 100% !important;
  margin-top: 20px;
`;
exports.NoMatchResultHeader = styled_components_1.default.h2 `
  margin-bottom: 0;
`;
exports.NoMatchResultDesc = styled_components_1.default.p ``;
//# sourceMappingURL=SwitchMenu.styles.js.map